import { render, staticRenderFns } from "./EditSPEmployeeProfileLayout.vue?vue&type=template&id=77896678&scoped=true"
import script from "./EditSPEmployeeProfileLayout.vue?vue&type=script&lang=js"
export * from "./EditSPEmployeeProfileLayout.vue?vue&type=script&lang=js"
import style0 from "./EditSPEmployeeProfileLayout.vue?vue&type=style&index=0&id=77896678&prod&lang=scss"
import style1 from "./EditSPEmployeeProfileLayout.vue?vue&type=style&index=1&id=77896678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77896678",
  null
  
)

export default component.exports